import { render, staticRenderFns } from "./BusinessPhoneNumber.vue?vue&type=template&id=6a855b50&scoped=true&"
import script from "./BusinessPhoneNumber.vue?vue&type=script&lang=js&"
export * from "./BusinessPhoneNumber.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPhoneNumber.vue?vue&type=style&index=0&id=6a855b50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a855b50",
  null
  
)

export default component.exports